export const getLocalized = (obj, lang) => obj?.[lang] || obj?.en || obj?.tr || obj?.ru || '';
